/* eslint-disable import/prefer-default-export */
export const STATE_MANDATORY_COUNTRIES = ["IND", "USA", "MEX", "CAN", "CHN"];
export const COUNTRIES_WITH_STATES = [
  "AFG", // Afghanistan
  "AUS", // Australia
  "AUT", // Austria
  "BRA", // Brazil
  "COL", // Colombia
  "ETH", // Ethiopia
  "DEU", // Germany
  "IND", // India
  "JPN", // Japan
  "MYS", // Malaysia
  "MEX", // Mexico
  "FSM", // Micronesia
  "MMR", // Myanmar
  "NGA", // Nigeria
  "PLW", // Palau
  "SOM", // Somalia
  "KOR", // South Korea
  "SSD", // South Sudan
  "SDN", // Sudan
  "USA", // United States
  "VEN", // Venezuela
];

/** Countries where selecting a city may auto-fill state_id from the city option. */
export const CITY_SELECT_STATE_AUTOFILL_COUNTRIES = [
  "ARG", // Argentina
  "AUS", // Australia
  "BRA", // Brazil
  "CAN", // Canada
  "CHN", // China
  "IND", // India
  "IDN", // Indonesia
  "JPN", // Japan
  "MYS", // Malaysia
  "MEX", // Mexico
  "NGA", // Nigeria
  "PAK", // Pakistan
  "PHL", // Philippines
  "ZAF", // South Africa
  "KOR", // South Korea
  "THA", // Thailand
  "USA", // United States
  "VEN", // Venezuela
  "VNM", // Vietnam
];

export const COUNTRIES_WITH_PROVINCES = [
  "ARG", // Argentina
  "BEL", // Belgium
  "KHM", // Cambodia
  "CMR", // Cameroon
  "CAN", // Canada
  "CHN", // China
  "CUB", // Cuba
  "COD", // Democratic Republic of the Congo
  "DOM", // Dominican Republic
  "ECU", // Ecuador
  "IDN", // Indonesia
  "IRN", // Iran
  "ITA", // Italy
  "LAO", // Laos
  "MNG", // Mongolia
  "NPL", // Nepal
  "NLD", // Netherlands
  "PAK", // Pakistan
  "PAN", // Panama
  "PNG", // Papua New Guinea
  "PHL", // Philippines
  "RWA", // Rwanda
  "ZAF", // South Africa
  "ESP", // Spain
  "LKA", // Sri Lanka
  "THA", // Thailand
  "TUR", // Turkey
  "VNM", // Vietnam
  "ZMB", // Zambia
  "ZWE", // Zimbabwe
];
export const COUNTRIES_WITH_STATES_OR_PROVINCES = [...new Set([...COUNTRIES_WITH_STATES, ...COUNTRIES_WITH_PROVINCES])];
